import React, { ReactNode, useState } from 'react';
import { Modal, ModalFuncProps } from '@sinohealth/butterfly-ui-components/lib';
import { ExclamationCircleFilled, QuestionCircleTwoTone } from '@ant-design/icons';
import styles from './index.less';

const { confirm } = Modal;

export type ConfirmModelProps = {
  fun: 'success' | 'info' | 'error' | 'warning';
  subtitle?: string;
  node?: ReactNode;
} & ModalFuncProps;

const icons = {
  success: <QuestionCircleTwoTone twoToneColor="#FFBF00" />,
  info: <ExclamationCircleFilled style={{ color: '#217BA0' }} />,
  error: <ExclamationCircleFilled style={{ color: '#F53F3F' }} />,
  warning: <ExclamationCircleFilled style={{ color: '#FFBF00' }} />,
};

export const btnType: any = {
  success: 'primary',
  info: 'primary',
  warning: 'primary',
  error: 'primary',
};

const ConfirmModel = (props: ConfirmModelProps) => {
  // eslint-disable-next-line dot-notation
  //   return Modal[props.fun]({ ...props });
  return confirm({
    ...props,
    centered: true,
    className: styles.confirm,
    icon: icons[props.fun],
    okButtonProps: { danger: props.fun === 'error', type: btnType[props.fun] },
    content: props.node,
  });
};

ConfirmModel.defaultProps = {};

export default ConfirmModel;
